module.exports = __webpack_public_path__ + "static/media/Done_ring_round_light.47e5fc7f.svg";